import {
  GET_TIPOLOGIAS_REQUEST,
  GET_TIPOLOGIAS_SUCCESS,
} from '../../actions/constants/tipologias/tipologias.constants';

const initialState = {
  loading: false,
  listado: [],
  total: 0,
  page: 1,
  start: 0,
  limit: 9999,
  filter: null,
};

export default function tipologiasReducer(state = initialState, { type, payload }) {
  switch (type) {
    case GET_TIPOLOGIAS_REQUEST: {
      return {
        ...state, loading: true,
      };
    }

    case GET_TIPOLOGIAS_SUCCESS: {
      const {
        datos, total, page, start, limit,
      } = payload;
      return {
        ...state, listado: [...datos], total, loading: false, page, start, limit,
      };
    }

    default:
      return state;
  }
}
